import styled, { css } from 'styled-components';
import { colors } from '@dexma/ui-components';
import Branding from 'domain/entity/branding';
import { GridOrigin } from 'adapter/in/dashboards/containers/Grid';

type StyledGrabbaleProps = {
    $editable: boolean;
    $isWidgetSelected: boolean;
    $branding: Branding;
    $isEditEnabled: boolean;
    $isDashboardFrame: boolean;
    $gridOrigin: GridOrigin;
    $isEditingLayout: boolean;
    $isReportInstance?: boolean;
};

const getBorderStyle = (props: StyledGrabbaleProps) => {
    if (props.$isReportInstance || props.$isDashboardFrame) {
        return '2px solid transparent';
    }

    if (props.$gridOrigin === GridOrigin.REPORT) {
        return props.$editable ? `2px dashed ${colors.gray500}` : `2px solid ${colors.gray300}`;
    }

    return props.$editable ? `2px dashed ${colors.gray500}` : '2px solid transparent';
};

export const StyledGrabbale = styled.div<StyledGrabbaleProps>`
    width: 100%;
    height: 100%;
    border-radius: 10px;
    border: ${(props) => getBorderStyle(props)};
    background-color: ${colors.white};
    box-shadow: ${(props) =>
        props.$gridOrigin === GridOrigin.REPORT && !props.$isEditingLayout
            ? 'none'
            : '0px 0px 1px rgba(64, 65, 69, 0.08), 0px 1px 3px rgba(64, 65, 69, 0.1)'};
    z-index: 99999;
    ${(props) =>
        props.$isEditEnabled &&
        !props.$editable &&
        !props.$isDashboardFrame &&
        css`
            &:hover {
                border: 2px solid ${props.$branding.primaryColor};
            }
        `}

    ${(props) =>
        props.$isWidgetSelected &&
        props.$isEditEnabled &&
        !props.$editable &&
        css`
            border: 2px solid ${colors.teal500}!important;
        `}

    ${(props) =>
        props.$editable &&
        css`
            cursor: move; /* Fallback if grab cursor is unsupported */
            cursor: grab;
            cursor: -moz-grab;
            cursor: -webkit-grab;

            /* Apply a "closed-hand" cursor during drag operation. */
            :active {
                cursor: grabbing;
                cursor: -moz-grabbing;
                cursor: -webkit-grabbing;
            }
        `}
`;
